module.exports = __webpack_public_path__ + "img/icon-exit-white.c76c311c.svg";